import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBauhausShape8 = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 300,
	height: 300,
	viewBox: "0 0 300 300",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_11899_13822)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0 0C0 39.7866 15.8002 77.934 43.9282 106.062C72.0563 134.19 110.213 150 150 150V0H0ZM150 150H300V0C260.213 0 222.056 15.8002 193.928 43.9282C165.8 72.0563 150 110.213 150 150ZM150 150V300H300C300 260.223 284.2 222.066 256.072 193.938C227.944 165.81 189.787 150.01 150 150.01V150ZM150 150H0V300C39.7866 300 77.9437 284.2 106.072 256.072C134.2 227.944 150 189.787 150 150.01V150Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_11899_13822",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 300,
			height: 300,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgBauhausShape8);
const Memo = memo(ForwardRef);
export default Memo;
